import React, { useEffect, useState } from "react";
import { ModalLoadingScreen } from "../../LoadingScreen";
import { Container, Form, FormButton, FormContent, FormH1, FormWrap, QrWrapper, Text } from "../QrCodeFormElements";
import { useXRPLWalletConnect } from "../../../hooks/xrplAppKit/XRPLWalletProvider"; 
import axiosInstance from "../../Authorization/client";
import { JoeySendTransaction, XRPLSendTransaction } from "./XRPLSendTransaction";
import { useModal } from "../../Modal/ModalContext";
import { WALLET_TYPES } from "../../../utils/Enum";
import { useJoeyWallet } from "../../../hooks/xrplAppKit/joeyWallet/JoeyWalletProvider";

const WalletConnect = ({ heading, body, type, cancelQr, onSuccess, onFail }) => {
  // Use the native functions exposed by our updated Provider
  const { session, account, isReady, connect, disconnect } = useXRPLWalletConnect();
  const {openModal, modalContent, closeModal} = useModal()
  const [errMsg, setError] = useState()
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch payload automatically when a session exists
  useEffect(() => {
    if (session && account && !payload) {
      setLoading(true);
      createTransaction(session)
    }
  }, [session, account, payload, body, type]);

  const createTransaction = async (activeSession) => {
    if (!activeSession) return;
    setLoading(true);
    openModal()
    modalContent(<ModalLoadingScreen/>)
    try {
      const resp = await axiosInstance.post(`/api/xrpl/createTransaction`, { ...body, sender: activeSession?.namespaces?.xrpl?.accounts[0]?.split(":")[2], type, txInfo: {...body, type}, walletType: WALLET_TYPES.WALLET_CONNECT })
;
      if (resp.data && !resp.data.error) {
        setPayload(resp.data);
        setLoading(false);
modalContent( <XRPLSendTransaction
          topic={session?.topic}
          account={activeSession?.namespaces?.xrpl?.accounts[0]?.split(":")[2]}
          payload={resp.data.payload}
          invoice={resp.data.invoice}
          method={"xrpl_signTransaction"}
          type={type}
          body={body}
          onSuccess={onSuccess}
          onFail={onFail}
          heading={heading}
        />)
      } else {
        throw new Error(resp.data?.error || "Failed to create transaction");
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      setError("Oops! Something went wrong. Please try again.");
    }
  };

  return (
    <>
      {loading && <ModalLoadingScreen />}
        <FormContent>
          <Form>
            <FormH1>{heading || (session ? "Sign Transaction" : "Connect Wallet")}</FormH1>
            
            <QrWrapper>
              {!session ? (
                                            <>
                                              
                                                    <FormButton
                                                      onClick={() => {
                                                       connect()
                                                      }
                                                    } disabled={!isReady}
                                                    >
                                                      Connect Wallet
                                                    </FormButton>
                                                
                                            </>
                                          ) : (
                payload && (
                  <div style={{ textAlign: "center" }}>
                    <Text style={{ marginBottom: "15px" }}>Connected: <b>{account}</b></Text>
                    <XRPLSendTransaction 
                      topic={session.topic}
                      account={account}
                      payload={payload}
                      method={payload?.memo ? 'xrpl_signTransaction' : 'xrpl_signAndSubmit'}
                      onSuccess={onSuccess}
                      onFail={onFail}
                    />
                    <FormButton onClick={disconnect} transparent style={{ marginTop: "15px" }}>
                      Disconnect
                    </FormButton>
                  </div>
                )
              )}
            </QrWrapper>

            <FormButton onClick={cancelQr} transparent>Cancel</FormButton>
          </Form>
        </FormContent>
      
    </>
  );
};

export const JoeyWalletConnect = ({ heading, body, type, cancelQr, onSuccess, onFail }) => {
  // Use the native functions exposed by our updated Provider
  const { session, setSession, account, disconnect, connect, isReady, reconnect, actions, provider } =
      useJoeyWallet();
  const {openModal, modalContent, closeModal} = useModal()
  const [errMsg, setError] = useState()
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch payload automatically when a session exists
  useEffect(() => {
    if (session && account && !payload) {
      setLoading(true);
      createTransaction(session)
    }
  }, [session, account, payload]);

  const createTransaction = async (activeSession) => {
    if (!activeSession) return;
    setLoading(true);
    openModal()
    modalContent(<ModalLoadingScreen/>)
    try {
      const resp = await axiosInstance.post(`/api/xrpl/createTransaction`, { ...body, sender: activeSession?.namespaces?.xrpl?.accounts[0]?.split(":")[2], type, txInfo: {...body, type}, walletType: WALLET_TYPES.JOEY_WALLET })
;
      if (resp.data && !resp.data.error) {
        setPayload(resp.data);
        setLoading(false);
modalContent( <JoeySendTransaction
          topic={session?.topic}
          account={activeSession?.namespaces?.xrpl?.accounts[0]?.split(":")[2]}
          payload={resp.data.payload}
          invoice={resp.data.invoice}
          method={"xrpl_signTransaction"}
          type={type}
          body={body}
          onSuccess={onSuccess}
          onFail={onFail}
          heading={heading}
        />)
      } else {
        throw new Error(resp.data?.error || "Failed to create transaction");
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      setError("Oops! Something went wrong. Please try again.");
    }
  };

  return (
    <>
      {loading && <ModalLoadingScreen />}
      
        {!loading && <FormContent>
          <Form>
            <FormH1>{heading || (session ? "Sign Transaction" : "Connect Wallet")}</FormH1>
            
            <QrWrapper>
              {!session && (
                                            <>
                                              
                                                    <FormButton
                                                      onClick={() => {
                                                       connect()
                                                      }
                                                    } disabled={!isReady}
                                                    >
                                                      Connect Wallet
                                                    </FormButton>
                                
                                            </>
                                          )}
            </QrWrapper>

            <FormButton onClick={cancelQr} transparent>Cancel</FormButton>
          </Form>
        </FormContent>}
    </>
  );
};

export default WalletConnect;